import * as request from '@/utils/request'

export default {

    /**
     * 必填筛选条件
     * @description 获取产品库数据列表
     * @param {*} data
     * @returns
     */
    getProductVideoList(data) {
        return request.post('/product_video/list', data)
    },
    //获取产品下拉
    getProductVideoOptions(data) {
        return request.post('/product_video/product_option', data)
    },
    getProductVideoLog(data) {
        return request.post('/product_video/log', data)
    },

    /**
     * 保存
     * @description 保存产品库数据
     * @param {*} data
     * @returns
     */
    saveProductVideo(data) {
        return request.post('/product_video/store', data)
    },
    /**
     * 保存产品信息-分段
     * @param formName
     * @param data
     * @returns {Promise}
     */
    saveProductVideoPart(formName, data) {
        return request.post('/product_video/save', { form_name: formName, data: data })
    },
    /**
     * 获取产品库
     * @param {*} id
     * @returns {Promise}
     */
    getProductVideoInfo(id) {
        let data = { id: id }
        return request.post('/product_video/get_info', data)
    },

    /**
     * 删除产品库
     * @param value
     * @returns {Promise}
     */
    delProductVideo(value) {
        let data = { ids: value }
        return request.post('/product_video/delete', data)
    },
    /**
     * 选品列表
     * @param data
     * @returns {Promise}
     */
    getVideoScheduleProductList(data) {
        return request.post('/product_video/get_lb_record', data)
    },
    /**
     * 导出
     * @param data
     * @returns {Promise}
     */
    exportProductVideo(data) {
        return request.postBlob('/product_video/export', data)
    },
    /**
     * 异步导出：返回任务ID
     * 根据任务可下载生成的文件
     * @param data
     * @returns {Promise}
     */
    asyncExportProductVideo(data) {
        return request.post('/product_video/async_export', data)
    },
}
